export interface ExchangeProtectionResponse {
  success: boolean;
  data: Array<ExchangeProtectionItem>;
  total: number;
}

export interface ExchangeProtectionItem {
  _id: string;
  quarantinedDate: string;
  actionStatus: number;
  source: Source;
  email: Email;
  item: Item;
  detection: Detection;
  threats: Threats;
  isGhost?: boolean;
}

export interface Source {
  endpointId: string;
  protectedEntity: ProtectedEntity;
  company: Company;
}

export interface ProtectedEntity {
  eps: Eps;
  sve: Sve;
  name: string;
  ip: string;
}

export interface Sve {
  id?: any;
  name?: any;
  type?: any;
  svaId?: any;
  sveMultiPlatform: boolean;
}

export interface Eps {
  id: string;
  name: string;
  type: number;
}

export interface Company {
  id: string;
  name: string;
}

export interface Email {
  subject: string;
  senderIp: string;
  senderEmail: string;
  recipients: string;
  realRecipients: string;
}

export interface Item {
  id: string;
  type: number;
  name: string;
  moduleId: number;
}

export interface Detection {
  rule: string;
  pointType: number;
  pointPath: string;
}

export interface Threats {
  name?: string;
  status?: number;
}
export interface DeleteSelectedResponse {
  nbOfCreatedTasks: number;
  success: boolean;
}
export interface SaveSelectedResponse {
  success: boolean;
}
export interface AvailableCompaniesResponse {
  data: Array<AvailableCompany>;
}
export interface AvailableCompany {
  name: string;
  _id: string;
}

export enum QuarantineExchangeMethod {
  READ_RECORDS = 'readRecords',
  CREATE_REMOVE_TASK = 'createRemoveTask',
  CREATE_REMOVE_ALL_TASK = 'createRemoveAllTask',
  CREATE_SAVE_TASK = 'createSaveTask',
  CREATE_RESTORE_ORIGINAL_TASK = 'createRestoreOriginalTask'
}

export enum CompanyEndpointMethod {
  GET_AVAILABLE_COMPANIES = 'getAvailableCompanies',
}
